import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderDetailsResponse,
  IInventoryPurchaseOrderDraftPropsBody,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";

AxiosCurlirize(axios, () => {});

type PurchaseOrderDetailsByNumberResponse = {
  status: boolean;
  message: string;
  data: IInventoryPurchaseOrderDraftPropsBody | null;
};

export const usePurchaseOrderDetailsByPoNumberAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (poNumber: string): Promise<PurchaseOrderDetailsByNumberResponse> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const encodedPONumber = encodeURIComponent(poNumber?.trim());

        const response = await axios
          .get(`${INVENTORY_MODULE?.PURCHASE_ORDER_DETAILS?.baseURL}?po_number=${encodedPONumber}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseOrderDetailsResponse>) => {
            if (res.data.status && res.data.data) {
              return {
                status: true,
                message: res.data.message || "PO details fetched successfully",
                data: res.data.data,
              };
            }

            return {
              status: false,
              message: res.data.message || "PO details not found",
              data: null,
            };
          })
          .catch((e: AxiosError) => {
            sendCurl(e?.config?.["curlCommand"]);
            captureError(e);

            return {
              status: false,
              message: "Unable to fetch PO details",
              data: null,
            };
          });

        return response;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          sendCurl(error?.config?.["curlCommand"]);
          captureError(error);
          return {
            status: false,
            message: error.response?.data?.message || "Unable to fetch PO details",
            data: null,
          };
        }

        return {
          status: false,
          message: "Unable to fetch PO details",
          data: null,
        };
      }
    },
    [configuration, captureError, sendCurl],
  );

  return { execute };
};